export default function fileNameFromURL(url: string) {
  const path = decodeURIComponent(new URL(url).pathname);
  const match = path.match(/\/([^/]+)$/);
  if (!match) return null;
  return match[1].replace(/\+/g, ' ');
}
